import { ReactTFC } from "../../../../utils/fp/missing-ts-parts";
import React from "react";

import { css } from "@emotion/react";

import { CSS_COLORS } from "../../../../styles/styles-css-variables";
import { CSS_MQ, CSS_MQ_ONLY } from "../../../../styles/breakpoints";
import { FONTS, fontSize } from "../../../../styles/fonts";
import type { TranslatedValue } from "@swo/storefront";
import { T } from "../../../../components/T";
import type { PDPInformationSetData } from "./PDPInformationSet";

export const PDPInformationSetDelivery: ReactTFC<{
  elements: PDPInformationSetData;
}> = props => {
  return (
    <div
      css={css`
        display: grid;
        grid-template-columns: repeat(3, 1fr);

        --p: 24px;
        grid-column-gap: 16px;
        ${CSS_MQ.atLeastMd} {
          --p: 30px;
          grid-column-gap: 24px;
        }

        padding-top: var(--p);
        padding-bottom: var(--p);

        ${CSS_MQ_ONLY.sm} {
          padding-left: 12px;
          padding-right: 12px;
        }

        ${CSS_MQ.atLeastLg} {
          padding-left: 6px;
          padding-right: 6px;
        }

        border-top: 1px solid ${CSS_COLORS.Grey5};
        border-bottom: 1px solid ${CSS_COLORS.Grey5};
      `}
    >
      {props.elements.map(({ IconComponent, label }) => {
        return <PDPInformationSetIconLabel key={label.key} IconComponent={IconComponent} label={label} />;
      })}
    </div>
  );
};

export const PDPInformationSetIconLabel: React.FC<{
  IconComponent: React.FunctionComponent;
  label: TranslatedValue;
}> = props => {
  return (
    <div
      css={css`
        display: grid;

        ${CSS_MQ.atMostMd} {
          grid-template-rows: 32px auto;
          grid-gap: 6px;
        }
        ${CSS_MQ.atLeastLg} {
          grid-template-columns: 40px auto;
          grid-gap: 8px;
        }
      `}
    >
      <props.IconComponent
        css={css`
          align-self: flex-start;
          ${CSS_MQ.atLeastLg} {
            justify-self: center;
          }

          height: 32px;
          max-width: 100%;
          stroke-width: 1px;
        `}
      />
      <span
        css={[
          FONTS.SwarovskiFutura300,
          fontSize.x2,
          css`
            text-align: left;
            display: flex;

            ${CSS_MQ.atLeastLg} {
              align-items: center;
            }
            justify-content: flex-start;

            text-wrap: balance;
          `,
        ]}
      >
        <T>{props.label}</T>
      </span>
    </div>
  );
};
